import React from "react";
import { useStyles } from "./TakisGrid.styles";
import TakisGridItem from "./TakisGridItem";
import TakisDivider from "./TakisDivider";
import Grid from "@material-ui/core/Grid";
import PropTypes from "prop-types";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";

function TakisGrid({ title, items, itemsSize, marginType, flattop }) {
  const classes = useStyles();
  const theme = useTheme();
  const onMobile = useMediaQuery(
    theme.breakpoints.down(theme.breakpoints.values.md)
  );
  const isWide = itemsSize === "wide";

  TakisGrid.propTypes = {
    items: PropTypes.array
  };

  return (
    <div className={`
        ${classes.takisGridContainer}
        ${flattop ? 'flattop' : ''}
      `}>
      <div className={`${classes.takisGrid}`}>
        <h2 className={`${classes.title}`}>{title}</h2>
        <Grid
          className={`${classes.takisGridNoPadding}`}
          container
          justifyContent="center"
          component="ul"
          >
          {items.map((item, index) => (
            <Grid
              className={`${classes.takisGridItemContainer}`}
              item
              data-aos="fade-up"
              key={index}
              xs={12}
              sm={12}
              md={6}
              lg={isWide ? 6 : 4}
              component="li"
              >
              <TakisGridItem
                frontImageSrc={item.frontImageSrc}
                frontImageAlt={item.frontImageAlt}
                backLayerSrc={item.backLayerSrc}
                backLayerAlt={item.backLayerAlt}
                middleLayerSrc={item.middleLayerSrc}
                middleLayerAlt={item.middleLayerAlt}
                isWide={isWide}
                cta={item.cta}
                description={item.description}
                itemIndex={index}
                onMobile={onMobile}
              />
            </Grid>
          ))}
        </Grid>
      </div>
      <TakisDivider
        marginModifier={`${
          marginType === 1
            ? classes.gridDividerMarginHome
            : classes.gridDividerMargin
        }`}
        backgroundColor="gridPurple"
      />
    </div>
  );
}

export default TakisGrid;
